import { useEffect } from 'react'
import { enqueueSnackbar } from 'notistack'
import { useNavigate } from 'react-router'

import { LoginView as SharedLoginView } from '@/components/_legacy/Login/LoginView'
import PasswordResetReceivedNotification from '@/components/_legacy/PasswordResetReceivedNotification'
import { DGE_AUTH_METHOD, PLATFORM } from '@/constants/platform'
import { ROUTE_URL } from '@/router/constants'
import { forgotPassword, login } from '@/service/authService'
import { useAuthStore } from '@/stores/useAuthStore'
import { DGEAuthMethod, Platform } from '@/types/platform'
import { makeErrorMessage } from '@/utils/loginView/makeErrorMessage'

export function LoginView() {
  const navigate = useNavigate()
  const setPlatform = useAuthStore((state) => state.setPlatform)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTE_URL.OPERATORS.DEFAULT)
    }
  }, [isAuthenticated, navigate])

  const signIn = async (
    email: string,
    password: string,
    platform: Platform,
    authMethod?: DGEAuthMethod
  ): Promise<void> => {
    setPlatform(platform)

    try {
      if (platform === PLATFORM.DGE && authMethod) {
        await login(email, password, platform, authMethod)
      } else {
        await login(email, password, platform)
      }

      if (authMethod === DGE_AUTH_METHOD.KEYCLOAK) {
        return
      }

      if (platform === PLATFORM.DGE || platform === PLATFORM.DDE) {
        navigate(ROUTE_URL.OPERATORS.DEFAULT)
        return
      }
    } catch (err) {
      if (authMethod !== DGE_AUTH_METHOD.KEYCLOAK) {
        let message = 'Unknown Error'
        if (typeof err === 'string') {
          message = makeErrorMessage(err)
        } else if (err instanceof Error) {
          if (err.message) {
            message = makeErrorMessage(err.message)
          }
        }

        enqueueSnackbar(message, { variant: 'error' })
      }
    }
  }

  const handleForgotPassword = async (email: string, platform: Platform) => {
    setPlatform(platform)
    try {
      await forgotPassword(email)
      enqueueSnackbar(<PasswordResetReceivedNotification />, { variant: 'success' })
    } catch (err) {
      if (err instanceof Error) {
        const message = makeErrorMessage(err.message)
        enqueueSnackbar(message, { variant: 'error' })
      }
    }
  }

  return <SharedLoginView forgotPassword={handleForgotPassword} signIn={signIn} />
}
